import { useTranslation } from 'react-i18next'

import Button, { BUTTON_HEIGHT_32 } from '../../../../Button'
import { ListItemIcons } from '../../../../ListItem'

import CopyIcon from '../../../../../icons/copy.svg'

function EmailProfileWidgetParticipantsItemIcons({
  copied,
  isHovered,
  onCopy,
  ...restProps
}) {
  const { t } = useTranslation()

  return (
    <ListItemIcons {...restProps}>
      {isHovered ? (
        <Button.Outlined
          isGrey
          beforeIconProps={{ Icon: CopyIcon }}
          disabled={copied}
          height={BUTTON_HEIGHT_32}
          tooltip={t(
            copied
              ? 'EmailProfile.ParticipantsWidgetItemCopyButtonDisabledTooltipKey'
              : 'EmailProfile.ParticipantsWidgetItemCopyButtonTooltipKey'
          )}
          onClick={onCopy}
        />
      ) : null}
    </ListItemIcons>
  )
}

export default EmailProfileWidgetParticipantsItemIcons
